import { SeasonModel } from "../../models"
import InputText from "component/inputText/inputText"
import IconsColor from "util/iconsColor"
import { Grid } from "@mui/material"
import { toTitleCase } from "util/textcase"
interface SeasonListProps {
    seasons: SeasonModel[]
    onSeasonNameChange: (index: number, value: string) => void
    onDeleteSeason: (index: number) => void
    onAddSeason: () => void
    /** false while any season name is empty — "+ Season" is greyed out and not clickable */
    canAddSeason: boolean
    getSeasonNameError: (index: number, seasonName: string) => string | undefined
}

const SeasonList = ({
    seasons,
    onSeasonNameChange,
    onDeleteSeason,
    onAddSeason,
    canAddSeason,
    getSeasonNameError,
}: SeasonListProps) => {
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 10, lg: 10 }}>
            <b>Season</b>
            {seasons.map((season: SeasonModel, index: number) => {
                return (
                    <div key={index} className="season-input-row">
                        <div className="season-input-wrapper">
                            <InputText
                                label={""}
                                value={toTitleCase(season.season_name) || ""}
                                onChange={(e) => onSeasonNameChange(index, toTitleCase(e.target.value))}
                                error={getSeasonNameError(index, season.season_name || "")}
                            />
                        </div>
                        <button
                            type="button"
                            className="delete-icon-button"
                            onClick={() => onDeleteSeason(index)}
                            style={{ display: seasons.length === 1 ? "none" : "block" }}
                        >
                            <IconsColor
                                iconName="deleteIcon"
                                width="20px"
                                height="20px"
                                fillColor="none"
                                strokeColor="currentColor"
                            />
                        </button>
                    </div>
                )
            })}
           
            <p>
                <b
                    className="add-season-button"
                    onClick={canAddSeason ? onAddSeason : undefined}
                    aria-disabled={!canAddSeason}
                    style={canAddSeason ? undefined : { opacity: 0.5, cursor: "not-allowed" }}
                >
                    + Season
                </b>
            </p>
            </Grid>
        </Grid>
    )
}

export default SeasonList
